import React, { useState } from 'react';
import { ArrowRight, Check, Eye, FileDown, Loader2, Printer, QrCode } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '../../components/ui/Button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/Dialog';
import { PageHeader } from '../../components/admin/PageHeader';
import { WorkflowStepper } from '../../components/admin/WorkflowStepper';
import { Panel } from '../../components/Panel';
import { A4Frame } from '../../components/notice/A4Frame';
import { SecureNotice } from '../../components/notice/SecureNotice';
import { useDemo } from '../../contexts/DemoContext';
import { noticeMeta } from '../../data/sampleCase';
export function NoticeGeneration() {
  const navigate = useNavigate();
  const {
    record,
    stage,
    completeStage
  } = useDemo();
  const [qr, setQr] = useState(stage >= 6);
  const [qrLoading, setQrLoading] = useState(false);
  const [pdf, setPdf] = useState(false);
  const [preview, setPreview] = useState(false);
  const genQr = () => {
    setQrLoading(true);
    setTimeout(() => {
      setQrLoading(false);
      setQr(true);
      completeStage(Math.max(stage, 6));
      toast.success('নিরাপদ QR কোড তৈরি হয়েছে', {
        description: `Verification ID: ${noticeMeta.verificationId}`
      });
    }, 1100);
  };
  const genPdf = () => {
    if (!qr) return toast.error('PDF তৈরির পূর্বে QR তৈরি করুন');
    setPdf(true);
    toast.success('নিরাপদ PDF তৈরি হয়েছে', {
      description: 'DMP-DOC-2025-0748-V1.pdf • ডিজিটালি স্বাক্ষরিত'
    });
  };
  const data: [string, string][] = [['স্মারক নং', noticeMeta.memoNo], ['ইস্যুর তারিখ', noticeMeta.issueDate], ['প্রাপক', record.owner], ['ঠিকানা', record.address], ['মোবাইল', record.mobile], ['মামলা নং', record.caseNo], ['মামলার তারিখ', record.caseDate], ['মামলার সময়', record.caseTime], ['গাড়ির রেজিস্ট্রেশন', record.vehicle], ['অপরাধের বিবরণ', record.offence], ['অপরাধের স্থান', record.location], ['আইনের ধারা', record.law], ['হাজিরার তারিখ/সময়', `${record.hearingDate}, ${record.hearingTime}`], ['ইস্যুকারী কর্তৃপক্ষ', `${noticeMeta.signatory.title}, ${noticeMeta.signatory.dept}`]];
  return <div data-id="element-1195" data-mp="vxuyx551galn">
      <PageHeader screen="WEB SCREEN 09" title="নিরাপদ প্রসিকিউশন নোটিশ তৈরি" subtitle="অনুমোদিত তথ্য স্বয়ংক্রিয়ভাবে মানসম্মত টেমপ্লেটে (T-2025.06 v3) বসানো হয়েছে" actions={<>
            <Button variant="outline" onClick={() => setPreview(true)} data-id="element-1197" data-mp="1jp0dzi35myuw"><Eye className="h-4 w-4" data-id="element-1198" data-mp="1jqbk3ok2oip6" /> নোটিশ প্রিভিউ</Button>
            <Button variant="outline" onClick={genQr} disabled={qr || qrLoading} data-id="element-1199" data-mp="1fmvngs806ich">{qrLoading ? <Loader2 className="h-4 w-4 animate-spin" data-id="element-1200" data-mp="1apdckwafdt1u" /> : qr ? <Check className="h-4 w-4" data-id="element-1201" data-mp="1aokf6lxcwfwd" /> : <QrCode className="h-4 w-4" data-id="element-1202" data-mp="48rr5fdy0i49" />} QR তৈরি করুন</Button>
            <Button variant="outline" onClick={genPdf} data-id="element-1203" data-mp="4a2z7ref8c16"><FileDown className="h-4 w-4" data-id="element-1204" data-mp="3vfcf2q8pb9x2" /> PDF তৈরি করুন</Button>
            <Button onClick={() => qr ? window.print() : toast.error('প্রিন্টের পূর্বে QR তৈরি করুন')} data-id="element-1205" data-mp="3vh5qsjy68kbx"><Printer className="h-4 w-4" data-id="element-1206" data-mp="2ayv3cf5n884f" /> প্রিন্ট করুন</Button>
          </>} data-id="element-1196" data-mp="vxl6lawitrcs" />
      <WorkflowStepper current={5} data-id="element-1207" data-mp="2fwd61nt2hr3z" />

      <div className="grid gap-6 xl:grid-cols-[420px_1fr]" data-id="element-1208" data-mp="2jxyqbu7xl7o7">
        <div className="space-y-6" data-id="element-1209" data-mp="2jwf8hz6mmokb">
          <Panel title="প্রসিকিউশন মামলার তথ্য" bodyClassName="p-0" data-id="element-1210" data-mp="2oo6ppj3w7hxs">
            <table className="w-full text-sm" data-id="element-1211" data-mp="2oqjh0mvjj4ni">
              <tbody data-id="element-1212" data-mp="2tob85eod2mqn">
                {data.map(([k, v]) => <tr key={k} className="border-b border-border last:border-0" data-id="element-1213" data-mp="2tpw0qyr47vlv">
                    <th className="w-[40%] bg-[#F4F7FB] px-4 py-2 text-left text-xs font-medium text-slate-600" data-id="element-1214" data-mp="2ykrymfj19d6w">{k}</th>
                    <td className="px-4 py-2" data-id="element-1215" data-mp="33juyllk5ot80">{v}</td>
                  </tr>)}
              </tbody>
            </table>
          </Panel>
          <Panel title="নিরাপত্তা উপাদান" data-id="element-1216" data-mp="198ztwuc3dyai">
            <ul className="space-y-2.5 text-sm" data-id="element-1217" data-mp="19a16x4co4uuv">
              {[['Verification ID', noticeMeta.verificationId, qr], ['নিরাপদ QR টোকেন', noticeMeta.token, qr], ['Document ID', noticeMeta.documentId, qr], ['ডিজিটাল স্বাক্ষর (SHA-256)', `${noticeMeta.hash.slice(0, 16)}…`, pdf], ['নিরাপদ PDF', 'DMP-DOC-2025-0748-V1.pdf', pdf]].map(([k, v, ok]) => <li key={k as string} className="flex items-center justify-between gap-3" data-id="element-1218" data-mp="mz7y9rz2pnd6">
                  <span className="flex items-center gap-2" data-id="element-1219" data-mp="3vd87qqevqclp">
                    <span className={`flex h-5 w-5 items-center justify-center rounded-full ${ok ? 'bg-[#16834A] text-white' : 'bg-slate-100'}`} data-id="element-1220" data-mp="3qewv67x79nzs">{ok && <Check className="h-3 w-3" data-id="element-1221" data-mp="8yoq8kulyhb0" />}</span>
                    {k}
                  </span>
                  <span className={`truncate font-mono text-xs ${ok ? 'text-slate-800' : 'text-slate-300'}`} data-id="element-1222" data-mp="47f6g0vqq871">{ok ? v : 'অপেক্ষমাণ'}</span>
                </li>)}
            </ul>
            <p className="mt-4 rounded-md bg-[#E8F1FA] p-3 text-xs text-[#0f4c80]" data-id="element-1223" data-mp="37ox7nph0cgyh">QR কোডে শুধুমাত্র নিরাপদ যাচাই টোকেন সংরক্ষিত — কোনো ব্যক্তিগত তথ্য সরাসরি পাঠযোগ্য নয়।</p>
            {qr && <Button className="mt-4 w-full" variant="secondary" onClick={() => navigate('/admin/dispatch')} data-id="element-1224" data-mp="1rxml110pz6yr">
                প্রিন্ট ও প্রেরণে যান <ArrowRight className="h-4 w-4" data-id="element-1225" data-mp="1e79g77j4k8dn" />
              </Button>}
          </Panel>
        </div>

        <Panel title="লাইভ নোটিশ প্রিভিউ" subtitle="A4 • নমুনা নোটিশ জলছাপ সহ" bodyClassName="bg-slate-200/70 p-4 md:p-6" data-id="element-1226" data-mp="1i5766ckpyyi3">
          <div className="mx-auto max-w-[794px] shadow-lg" data-id="element-1227" data-mp="2avywitf3ssxi">
            <A4Frame data-id="element-1228" data-mp="2avfhbkgu8in6"><SecureNotice data={record} showQr={qr} highlightQr={qrLoading} data-id="element-1229" data-mp="2av5xyfqat9qg" /></A4Frame>
          </div>
        </Panel>
      </div>

      <Dialog open={preview} onOpenChange={setPreview} data-id="element-1230" data-mp="21v94m0syrmp2">
        <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-4xl" data-id="element-1231" data-mp="21tppwemyhjpe">
          <DialogHeader data-id="element-1232" data-mp="lfzhwwspubah"><DialogTitle data-id="element-1233" data-mp="lg7t8k96x8jk">নোটিশ প্রিভিউ</DialogTitle></DialogHeader>
          <div className="bg-slate-100 p-4" data-id="element-1234" data-mp="qgn9bjkuwu58"><A4Frame data-id="element-1235" data-mp="qgvpbkca0fkn"><SecureNotice data={record} showQr={qr} data-id="element-1236" data-mp="qhotcdjuoqz3" /></A4Frame></div>
        </DialogContent>
      </Dialog>
    </div>;
}